<template>
  <Properties :component="component">
    <template #library-properties>
      <section class="tw-pt-36 md:tw-pt-48" :style="`background-color: var(--c-section_quaternary)`">
        <div class="container properties tw-grid tw-grid-cols-12 tw-items-start tw-gap-6">
          <div
            v-if="isExtendedFilterPopupVisible"
            class="tw-fixed tw-left-0 tw-top-0 tw-z-20 tw-h-screen tw-w-full tw-bg-black tw-opacity-40"
          ></div>
          <div class="tw-col-span-12 tw-w-full tw-pb-3">
            <div class="tw-block xl:tw-hidden">
              <lazy-library-properties-search-box
                v-model:filters="filters"
                v-model:locations="locations"
                v-model:search-input="searchInput"
                :search-type="searchType"
                @on-search="onSearch()"
                @open-extended-popup="openExtendedPopup()"
                :buy="vars.buyBool"
                :rent="vars.rentBool"
                version="v6"
                title=""
                :icon-only="false"
                :alternative-layout="true"
              />
            </div>
            <div class="tw-hidden xl:tw-block">
              <lazy-library-properties-search-box
                v-model:filters="filters"
                v-model:locations="locations"
                v-model:search-input="searchInput"
                :search-type="searchType"
                @on-search="onSearch()"
                @open-extended-popup="openExtendedPopup()"
                :buy="vars.buyBool"
                :rent="vars.rentBool"
                version="v7"
                title=""
                :icon-only="false"
                :alternative-layout="true"
              />
            </div>
            <template v-if="sidebarComponents && sidebarComponents.length">
              <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-10">
                <h5>{{ filterSummary }}</h5>
                <div class="tw-flex tw-items-center tw-gap-6">
                  <div
                    v-if="isApplicantExist"
                    class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                    @click="onClickedProfile()"
                  >
                    <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                    <p class="tw-mr-2 tw-truncate tw-capitalize">
                      {{ contactSession.name }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="tw-py-4"></div>
            </template>
          </div>
          <template v-if="sidebarComponents && sidebarComponents.length === 0">
            <div
              class="tw-col-span-12 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-py-4 lg:tw-flex-nowrap"
            >
              <h5 style="color: var(--c-text_secondary)">{{ filterSummary }}</h5>

              <div v-if="isApplicantExist" class="tw-flex tw-items-center tw-gap-4">
                <div
                  v-if="isApplicantExist"
                  class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                  @click="onClickedProfile()"
                >
                  <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                  <p class="tw-mr-2 tw-truncate tw-capitalize">
                    {{ contactSession.name }}
                  </p>
                </div>
                <button
                  v-if="isApplicantExist && !vars.customButtonLabelText"
                  class="n-primary"
                  @click="updateHeadsUpAlerts()"
                >
                  Update Heads Up Alert
                </button>
                <button
                  v-if="isApplicantExist && vars.customButtonLabelText"
                  class="n-primary"
                  @click="updateHeadsUpAlerts()"
                >
                  Update {{ vars.customButtonLabelText }} Alert
                </button>
              </div>
              <div class="tw-mt-6 tw-flex tw-w-full tw-justify-center md:tw-mt-12 lg:tw-mt-0 lg:tw-w-auto">
                <button v-if="!isApplicantExist" class="n-primary tw-w-full lg:tw-w-auto" @click="setupHeadsUpAlerts()">
                  REGISTER FOR ALERTS
                </button>
                <button v-if="isApplicantExist" class="n-primary tw-w-full lg:tw-w-auto" @click="updateHeadsUpAlerts()">
                  UPDATE ALERTS
                </button>
              </div>
            </div>
          </template>
          <div v-if="sidebarComponents && sidebarComponents.length" class="tw-order-2 tw-col-span-12 xl:tw-col-span-4">
            <div class="tw-flex tw-flex-col tw-gap-4 tw-pb-8">
              <theme8-available-components-for-sidebar
                key="property-sidebar"
                key-prefix="property-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="n-section-primary tw-z-auto" :style="`background-color: var(--c-section_primary)`">
        <div class="container properties tw-grid tw-grid-cols-12 tw-items-start tw-gap-6">
          <div class="tw-col-span-12 tw-w-full tw-pb-3">
            <!-- Mobile layout (stacked vertically) -->
            <div class="tw-flex tw-flex-col tw-gap-4 md:tw-hidden">
              <div class="tw-mb-4 tw-flex tw-items-center tw-justify-between">
                <h3 v-if="highlightedProperties.length === 0" class="tw-text-start">
                  <span class="n-title-secondary">{{ count }}</span> Results
                </h3>
                <h3 v-else-if="highlightedProperties.length > 0 && properties.length" class="tw-text-start">
                  Existing matches:
                  {{ count }} - {{ highlightedProperties.length }}
                  RESULTS
                </h3>
                <div
                  class="tw-flex tw-items-center tw-justify-center tw-border tw-p-[2px]"
                  style="border-color: var(--c-text_primary)"
                >
                  <button
                    class="n-link tw-flex tw-items-center tw-justify-center"
                    :style="{ padding: '10px !important', backgroundColor: isGridView ? 'var(--c-primary)' : '' }"
                    @click="toggleView('grid')"
                  >
                    <span class="tw-w-[24px]">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8.4 3H4.6C4.17565 3 3.76869 3.16857 3.46863 3.46863C3.16857 3.76869 3 4.17565 3 4.6V8.4C3 8.61011 3.04139 8.81817 3.12179 9.01229C3.2022 9.20641 3.32006 9.3828 3.46863 9.53137C3.6172 9.67994 3.79359 9.7978 3.98771 9.87821C4.18183 9.95861 4.38988 10 4.6 10H8.4C8.61011 10 8.81817 9.95861 9.01229 9.87821C9.20641 9.7978 9.3828 9.67994 9.53137 9.53137C9.67994 9.3828 9.7978 9.20641 9.87821 9.01229C9.95861 8.81817 10 8.61011 10 8.4V4.6C10 4.17565 9.83143 3.76869 9.53137 3.46863C9.23131 3.16857 8.82435 3 8.4 3ZM19.4 3H15.6C15.1757 3 14.7687 3.16857 14.4686 3.46863C14.1686 3.76869 14 4.17565 14 4.6V8.4C14 8.82435 14.1686 9.23131 14.4686 9.53137C14.7687 9.83143 15.1757 10 15.6 10H19.4C19.8243 10 20.2313 9.83143 20.5314 9.53137C20.8314 9.23131 21 8.82435 21 8.4V4.6C21 4.17565 20.8314 3.76869 20.5314 3.46863C20.2313 3.16857 19.8243 3 19.4 3ZM8.4 14H4.6C4.17565 14 3.76869 14.1686 3.46863 14.4686C3.16857 14.7687 3 15.1757 3 15.6V19.4C3 19.8243 3.16857 20.2313 3.46863 20.5314C3.76869 20.8314 4.17565 21 4.6 21H8.4C8.82435 21 9.23131 20.8314 9.53137 20.5314C9.83143 20.2313 10 19.8243 10 19.4V15.6C10 15.1757 9.83143 14.7687 9.53137 14.4686C9.23131 14.1686 8.82435 14 8.4 14ZM19.4 14H15.6C15.1757 14 14.7687 14.1686 14.4686 14.4686C14.1686 14.7687 14 15.1757 14 15.6V19.4C14 19.8243 14.1686 20.2313 14.4686 20.5314C14.7687 20.8314 15.1757 21 15.6 21H19.4C19.8243 21 20.2313 20.8314 20.5314 20.5314C20.8314 20.2313 21 19.8243 21 19.4V15.6C21 15.1757 20.8314 14.7687 20.5314 14.4686C20.2313 14.1686 19.8243 14 19.4 14Z"
                          stroke="black"
                          :style="{ stroke: isGridView ? 'white' : '' }"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <button
                    class="n-link tw-flex tw-items-center tw-justify-center"
                    :style="{ padding: '10px !important', backgroundColor: !isGridView ? 'var(--c-primary)' : '' }"
                    @click="toggleView('list')"
                  >
                    <span class="tw-w-[24px]">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8 6.5H20M8 12H20M8 17.5H20M4 6.5H5M4 12H5M4 17.5H5"
                          stroke="black"
                          :style="{ stroke: !isGridView ? 'white' : '' }"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              <div class="tw-flex tw-items-center tw-justify-between tw-gap-5">
                <div class="tw-flex tw-gap-4">
                  <div class="tw-flex tw-h-full tw-gap-0 tw-border-b tw-border-gray-300">
                    <button
                      class="n-link tw-border-b-2"
                      @click="((isCompleted = false), onSearch())"
                      :style="{
                        borderColor: !isCompleted ? '#e53935' : '#d1d5db',
                        color: !isCompleted ? '#e53935' : '#6b7280',
                        borderBottomStyle: 'solid',
                        paddingBottom: '10px !important',
                        paddingTop: '10px !important',
                        paddingRight: '20px !important',
                        paddingLeft: '5px !important',
                      }"
                    >
                      <h4>Active</h4>
                    </button>
                    <button
                      class="n-link tw-border-b-2"
                      @click="((isCompleted = true), onSearch())"
                      :style="{
                        borderColor: isCompleted ? '#e53935' : '#d1d5db',
                        color: isCompleted ? '#e53935' : '#6b7280',
                        borderBottomStyle: 'solid',
                        paddingBottom: '10px !important',
                        paddingTop: '10px !important',
                        paddingLeft: '20px !important',
                        paddingRight: '5px !important',
                      }"
                    >
                      <h4>Sold</h4>
                    </button>
                  </div>
                </div>
                <library-properties-sort-box
                  v-if="highlightedProperties.length === 0"
                  v-model:filter-criteria="filterCriteria"
                  version="v2"
                  @on-sort="sort()"
                  class="!tw-flex tw-w-full"
                />
              </div>
            </div>
            <!-- Desktop layout (horizontal) -->
            <div class="properties-match-card tw-hidden tw-items-center tw-justify-between md:tw-flex">
              <h3 v-if="highlightedProperties.length === 0">
                <span
                  :style="
                    vars.searchTypeText === 'sales'
                      ? 'color: var(--c-secondary)'
                      : vars.searchTypeText === 'lettings'
                        ? 'color: var(--c-tertiary)'
                        : ''
                  "
                  ><span class="n-title-secondary">{{ count }}</span></span
                >
                Results
              </h3>
              <h3 v-else-if="highlightedProperties.length > 0 && properties.length">
                Existing matches:
                <span
                  :style="
                    vars.searchTypeText === 'sales'
                      ? 'color: var(--c-secondary)'
                      : vars.searchTypeText === 'lettings'
                        ? 'color: var(--c-tertiary)'
                        : ''
                  "
                  >{{ count }} - {{ highlightedProperties.length }}</span
                >
                RESULTS
              </h3>
              <div class="tw-flex tw-items-center tw-justify-between tw-gap-5 md:tw-gap-10">
                <div class="tw-flex tw-gap-4">
                  <div class="tw-flex tw-h-full tw-gap-0 tw-border-b tw-border-gray-300">
                    <button
                      class="n-link tw-border-b-2"
                      @click="((isCompleted = false), onSearch())"
                      :style="{
                        borderColor: !isCompleted ? '#e53935' : '#d1d5db',
                        color: !isCompleted ? '#e53935' : '#6b7280',
                        borderBottomStyle: 'solid',
                        paddingBottom: '10px !important',
                        paddingTop: '10px !important',
                        paddingRight: '20px !important',
                        paddingLeft: '5px !important',
                      }"
                    >
                      <h4>Active</h4>
                    </button>
                    <button
                      class="n-link tw-border-b-2"
                      @click="((isCompleted = true), onSearch())"
                      :style="{
                        borderColor: isCompleted ? '#e53935' : '#d1d5db',
                        color: isCompleted ? '#e53935' : '#6b7280',
                        borderBottomStyle: 'solid',
                        paddingBottom: '10px !important',
                        paddingTop: '10px !important',
                        paddingLeft: '20px !important',
                        paddingRight: '5px !important',
                      }"
                    >
                      <h4>Sold</h4>
                    </button>
                  </div>
                </div>
                <library-properties-sort-box
                  v-if="highlightedProperties.length === 0"
                  v-model:filter-criteria="filterCriteria"
                  version="v2"
                  @on-sort="sort()"
                  class="!tw-flex tw-w-full"
                />
                <div
                  class="tw-flex tw-items-center tw-justify-center tw-border tw-p-[2px]"
                  style="border-color: var(--c-text_primary)"
                >
                  <button
                    class="n-link tw-flex tw-items-center tw-justify-center"
                    :style="{ padding: '10px !important', backgroundColor: isGridView ? 'var(--c-primary)' : '' }"
                    @click="toggleView('grid')"
                  >
                    <span class="tw-w-[24px]">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8.4 3H4.6C4.17565 3 3.76869 3.16857 3.46863 3.46863C3.16857 3.76869 3 4.17565 3 4.6V8.4C3 8.61011 3.04139 8.81817 3.12179 9.01229C3.2022 9.20641 3.32006 9.3828 3.46863 9.53137C3.6172 9.67994 3.79359 9.7978 3.98771 9.87821C4.18183 9.95861 4.38988 10 4.6 10H8.4C8.61011 10 8.81817 9.95861 9.01229 9.87821C9.20641 9.7978 9.3828 9.67994 9.53137 9.53137C9.67994 9.3828 9.7978 9.20641 9.87821 9.01229C9.95861 8.81817 10 8.61011 10 8.4V4.6C10 4.17565 9.83143 3.76869 9.53137 3.46863C9.23131 3.16857 8.82435 3 8.4 3ZM19.4 3H15.6C15.1757 3 14.7687 3.16857 14.4686 3.46863C14.1686 3.76869 14 4.17565 14 4.6V8.4C14 8.82435 14.1686 9.23131 14.4686 9.53137C14.7687 9.83143 15.1757 10 15.6 10H19.4C19.8243 10 20.2313 9.83143 20.5314 9.53137C20.8314 9.23131 21 8.82435 21 8.4V4.6C21 4.17565 20.8314 3.76869 20.5314 3.46863C20.2313 3.16857 19.8243 3 19.4 3ZM8.4 14H4.6C4.17565 14 3.76869 14.1686 3.46863 14.4686C3.16857 14.7687 3 15.1757 3 15.6V19.4C3 19.8243 3.16857 20.2313 3.46863 20.5314C3.76869 20.8314 4.17565 21 4.6 21H8.4C8.82435 21 9.23131 20.8314 9.53137 20.5314C9.83143 20.2313 10 19.8243 10 19.4V15.6C10 15.1757 9.83143 14.7687 9.53137 14.4686C9.23131 14.1686 8.82435 14 8.4 14ZM19.4 14H15.6C15.1757 14 14.7687 14.1686 14.4686 14.4686C14.1686 14.7687 14 15.1757 14 15.6V19.4C14 19.8243 14.1686 20.2313 14.4686 20.5314C14.7687 20.8314 15.1757 21 15.6 21H19.4C19.8243 21 20.2313 20.8314 20.5314 20.5314C20.8314 20.2313 21 19.8243 21 19.4V15.6C21 15.1757 20.8314 14.7687 20.5314 14.4686C20.2313 14.1686 19.8243 14 19.4 14Z"
                          stroke="black"
                          :style="{ stroke: isGridView ? 'white' : '' }"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                  <button
                    class="n-link tw-flex tw-items-center tw-justify-center"
                    :style="{ padding: '10px !important', backgroundColor: !isGridView ? 'var(--c-primary)' : '' }"
                    @click="toggleView('list')"
                  >
                    <span class="tw-w-[24px]">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8 6.5H20M8 12H20M8 17.5H20M4 6.5H5M4 12H5M4 17.5H5"
                          stroke="black"
                          :style="{ stroke: !isGridView ? 'white' : '' }"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tw-col-span-12"
            :class="{
              'tw-order-1': sidebarComponents && sidebarComponents.length,
            }"
          >
            <div v-if="filterSummary">
              <div class="tw-py-5" v-if="isLoading">
                <loader />
              </div>
              <div v-else-if="!isLoading && (highlightedProperties.length || properties.length)">
                <div v-if="locations.length > 0" class="row g-0 mb-3">
                  <div class="col-12">
                    <location-boxes v-model:locations="locations" :is-first-location-excluded="true" />
                  </div>
                </div>
                <template v-if="highlightedProperties.length">
                  <div
                    v-if="highlightedProperties.length > 0"
                    class="row g-0 mb-5 d-flex flex-row justify-content-between"
                  >
                    <div class="col-md-8 col-12 tw-mb-4 md:tw-mb-0">
                      <lazy-library-title tag="h1" :text="`New matches: ${newMatchesPropertyCount} properties`">
                      </lazy-library-title>
                    </div>
                    <div class="col-md-4 col-xl-2 col-12 d-flex justify-content-end">
                      <lazy-library-properties-sort-box v-model:filter-criteria="filterCriteria" @on-sort="sort()" />
                    </div>
                  </div>
                  <lazy-library-properties-page-list
                    v-if="highlightedProperties.length > 0"
                    :component="component"
                    :properties="highlightedProperties"
                    :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  />
                </template>
                <lazy-library-properties-page-list
                  :theme="theme"
                  :component="component"
                  :is-grid-view="isGridView"
                  :properties="properties"
                  :columns="vars.columnsNumber"
                  :pre-market-property-feature="vars.preMarketPropertyFeatureBool"
                  :version="vars.propertyListItemVersionText"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
                <div v-if="isPropertiesGridLoadMoreActive" class="tw-flex tw-items-center tw-justify-center tw-py-8">
                  <button class="n-secondary" @click="loadMore()">LOAD MORE</button>
                </div>
              </div>
              <div v-else-if="properties && properties.length === 0" class="tw-h-[40vh] tw-py-5">
                <lazy-theme4-base-not-found
                  title="Unfortunately, there are no properties matching your search criteria."
                >
                  <template #description>
                    Please
                    <nuxt-link to="/heads-up-alerts/register" :external="true" class="n-link"
                      ><u class="unknown-user-text text">setup a Heads Up property alert</u></nuxt-link
                    >
                    to be kept up to date in the future with new suggested properties that are based around your
                    specific criteria.
                  </template>
                </lazy-theme4-base-not-found>
              </div>
              <advanced-search
                v-if="!isMobile && isExtendedFilterPopupVisible"
                v-model:filters="filters"
                v-model:is-available="searchInput.is_available"
                :search-type="searchType"
                @on-open-all-styles-popup="allStylesConfig.isActive = true"
                @close-advanced-filter="closeAdvancedFilter()"
                theme="theme4"
                :component="component"
                @open-extended-popup="turnOffExtendedPopup()"
              />
              <popup
                v-if="isMobile"
                :config="advancedSearchConfig"
                custom-width="auto"
                class="advanced-mobile-popup"
                :custom-wrapper-class="propertiesConfig.advancedSearchMobilePopupBackgroundClass"
              >
                <template #content>
                  <advanced-search
                    v-if="isExtendedFilterPopupVisible"
                    v-model:filters="filters"
                    v-model:is-available="searchInput.is_available"
                    :search-type="searchType"
                    @on-open-all-styles-popup="allStylesConfig.isActive = true"
                    @on-searched="onSearch()"
                    @close-advanced-filter="closeAdvancedFilter()"
                    @open-extended-popup="turnOffExtendedPopup()"
                    theme="theme4"
                  />
                </template>
              </popup>
              <popup v-if="allStylesConfig.isActive" v-model:config="allStylesConfig">
                <template #content>
                  <all-property-types-styles
                    v-model:selected-type-styles="filters.property_types"
                    @close="allStylesConfig.isActive = false"
                    variant="v2"
                  />
                </template>
              </popup>
              <popup
                v-if="applicantProfilesPopupConfig.isActive"
                v-model:config="applicantProfilesPopupConfig"
                custom-width="500px"
                class="applicant-profile-popup"
              >
                <template #content>
                  <applicant-profiles
                    :search-type="searchType"
                    @on-selected-new-applicant="onSelectedNewApplicant()"
                    :is-visible-update-button="vars.applicantProfilesUpdateButtonBool"
                  />
                </template>
              </popup>
            </div>
          </div>
        </div>
      </section>
    </template>
  </Properties>
</template>

<script lang="ts">
import Properties from '~/components/library/Properties.vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme8Properties',

  mixins: [ComponentMixin],

  extends: Properties,

  components: {
    Properties,
  },

  data() {
    return {
      isGridView: true,
    };
  },
  methods: {
    toggleView(view: 'grid' | 'list') {
      this.isGridView = view === 'grid';
    },
  },
});
</script>

<style scoped>
.block {
  font-size: 40em !important;
  font-weight: 900;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: 1;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: -80px !important;
  left: -90px !important;
}
</style>
